"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InformPartnerIntegrationRequestRoutingKey = void 0;
var InformPartnerIntegrationRequestRoutingKey;
(function (InformPartnerIntegrationRequestRoutingKey) {
    InformPartnerIntegrationRequestRoutingKey["FetchPageForInformPartnerIntegrationModel"] = "informPartnerIntegrationRequest_FetchPageForInformPartnerIntegrationModel";
})(InformPartnerIntegrationRequestRoutingKey = exports.InformPartnerIntegrationRequestRoutingKey || (exports.InformPartnerIntegrationRequestRoutingKey = {}));
//# sourceMappingURL=types.js.map